import { render } from "./App.vue?vue&type=template&id=ef7fa09c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ef7fa09c&lang=css"

import exportComponent from "D:\\zhz\\projects\\bizspace\\wechatauthface\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__